//acordion
jQuery(function(){
  jQuery(".acMenu dt").on("click", function() {
    jQuery(this).next().slideToggle();
  });
});

//acordion
jQuery(function(){
  jQuery(".toggle-btn").on("click", function() {
    jQuery(this).next(".toggle-box").slideToggle();
    jQuery(this).toggleClass("fa-angle-up");
    jQuery(this).toggleClass("fa-angle-down");
  });
});


//caption
jQuery(function (){
  var str = $("h1.product-title").text();
  jQuery(".product-thumbnail").click(
    function(){
        alt = jQuery(this).find('img').attr('alt');
      if( alt != str){
        jQuery(".imgcaption").text(alt);
      }else {
        jQuery(".imgcaption").text(".");
      }
    }
  );
});

//delivery
$(document).ready( function() {
  $(function() {
    $("#date").datepicker( {
      minDate: +4,
      maxDate: '+15',
      dateFormat: 'yy年m月d日',
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
dayNames: ['日', '月', '火', '水', '木', '金', '土'],
dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
      //beforeShowDay: jQuery.datepicker.noWeekends
    } );
  });
});

//page top
$(function() {
  var topBtn = $('#to-pagetop');
  topBtn.hide();
    //btn fade-in
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    //scroll to top
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  });